module.exports = __webpack_public_path__ + "img/fo.6873b263.svg";